import React from 'react';
import { Link } from '@tcc/crate';

import { useAppSelector } from 'app/hooks';
import { getSupportInfo } from 'user/selectors';
import { getMessage } from 'util/locale';

const baseString = 'layers-usability-disclaimer';

const ZoneGenerationLayersUsabilityDisclaimer = () => {
  const { zoneGenerationInfoURL } = useAppSelector(getSupportInfo);
  
  return (
    <section data-test-id={baseString}>
      {getMessage('label-text__generate-zones-layers-usability-disclaimer')}
      {zoneGenerationInfoURL && <>
        {' '}
        <Link
          rel="noopener noreferrer"
          target="_blank"
          data-test-id={`${baseString}-learn-more-link`}
          href={zoneGenerationInfoURL}>
          {getMessage('link-text__zone-generation-learn-more')}
        </Link>
      </>}
    </section>
  );
};

export default ZoneGenerationLayersUsabilityDisclaimer;
